<div [formGroup]="form">
  <app-form-switch
    [checked]="!!form.get('status').value"
    labelPosition="before"
    [inline]="true"
    (valueChange)="onToggleNotification($event, toggle)"
    [disabled]="!(isAutomationLoaded$ | async)"
    matTooltip="Enable to receive notifications when AI-generated incidents are created"
    i18n-matTooltip
    #toggle
    i18n
  >
    Notifications
  </app-form-switch>
  <div class="text-sm text-muted" i18n>Choose how you'd like to be notified of new AI-generated Incidents</div>
  <mat-radio-group
    formControlName="handler"
    class="d-flex gap-3 mt-3"
    (change)="onToggleNotificationMethod($event.value)"
    [disabled]="!form.get('status').value"
    [style.filter]="!form.get('status').value ? 'grayscale(1)' : 'none'"
  >
    <mat-radio-button
      [value]="handlers.SendEmailMessage"
      matTooltip="Sends an email notification to the Admin/PM about the incident"
      i18n-matTooltip
      i18n
      >Email</mat-radio-button
    >
    <mat-radio-button
      [value]="handlers.SendSMSMessage"
      matTooltip="Sends a SMS notification to the Admin/PM about the incident"
      i18n-matTooltip
      i18n
      >SMS</mat-radio-button
    >
    <mat-radio-button
      [value]="handlers.SendPushNotification"
      disabled
      i18n
      style="opacity: 0.5"
      matTooltip="Coming soon"
      i18n-matTooltip
    >
      Push
    </mat-radio-button>
  </mat-radio-group>
  <app-user-select
    *ngIf="isAutomationExisting()"
    [ctrl]="form.get('users')"
    [disabled]="!form.get('status').value"
    label="Select Recipients"
    i18n-label
    placeholder="Recipients"
    i18n-placeholder
    [showPlaceholder]="false"
    matTooltip="Select the users who will receive the notification"
    i18n-matTooltip
  ></app-user-select>
</div>
